import React, { useContext, useState, useEffect } from 'react'
import { List, ListItem } from 'Lib/List'
import SectionHeader from 'Lib/Text/SectionHeader'
import PageLoader from 'Lib/Pageloader'
import Trips from 'Components/Home/icons/trips.svg'
import Warn from 'Lib/Status/icons/warning.svg'
import { Toast } from '@cleartrip/bento'

import { AccountsContext } from 'AccountsContext'
import {
  TRIPS_LOAD_MSG_HEADING,
  TRIPS_NOT_AVAILABLE_MESSAGE,
  TRIPS_LOAD_MSG_SUBHEADING,
  TRIPS_FETCH_ERROR_MESSAGE,
  LOAD_MORE_TEXT
} from 'AccountsConstants/language/trips'
// import { LOGOUT_LINK } from 'AccountsConstants/routes'
import { CLEVERTAP_EVENT_NAME, CLEVERTAP_PLATFORM } from 'AccountsConstants/clevertap'
import { TRIPS_PAGE_HEADER, TRIPLIST_ALL_HEADER } from 'AccountsConstants/language/account'
import { POST_CALL, FETCH_TRIPS_URL } from 'AccountsConstants/api_endpoints'
import {
  httpAxios,
  // readCookie,
  triggerClevertap,
  makeArrayUnique
  // navigateToExternalLink
} from 'AccountsUtils'
import { TripState, TripListContext } from '../context'
import TripsListItem from '../TripList/TripsListItem'
import './TripListAll.css'

const TripsList = props => {
  const {
    trips,
    fetchAllTrips,
    tripsLoading,
    tripsLoadingFailed,
    upcomingTripsCount,
    archivedTripsCall,
    archivedTripsCallHandler,
    updateTripsHandler,
    data,
    setDataHandler
  } = useContext(TripListContext)

  const {
    handleAccountsHeaderChange,
    handleUpdateBackButton
  } = useContext(AccountsContext)

  // const id = decodeURI(readCookie('userid')).split('|')[4]
  const getPageCount = (totalEls, elsPerPage) => {
    let totalPages = 1
    if (totalEls !== 0) {
      totalPages = Math.ceil(totalEls / elsPerPage)
    }
    return totalPages
  }
  useEffect(() => {
    // if (!id) {
    //   navigateToExternalLink(LOGOUT_LINK)
    // }
    const apiData = {
      firstCall: true,
      pageSize: 5,
      pageNo: 0,
      tripStatus: 'upcoming'
    }
    fetchAllTrips(apiData)
  }, [])

  useEffect(() => {
    handleAccountsHeaderChange({ header: TRIPS_PAGE_HEADER, subHeader: '' })
    handleUpdateBackButton(false)
  }, [])

  useEffect(() => {
    const clevertapData = {
      'event type': 'trip list viewed',
      platform: CLEVERTAP_PLATFORM,
      'bookings count': upcomingTripsCount
    }
    if (!tripsLoading || tripsLoadingFailed) {
      triggerClevertap(CLEVERTAP_EVENT_NAME, clevertapData)
    }
  }, [tripsLoading, tripsLoadingFailed])
  const [showLoadMore, showLoadMoreHandler] = useState(true)
  const [expiredTripsCount, updateExpiredTripsCount] = useState(0)
  const [archivedStarted, updateArchivedStart] = useState(false)
  const [archivedTripsCount, updateArchivedTripsCount] = useState(0)
  const [loadExpired, updateLoadExpired] = useState(false)
  const [showLoginSuccess, setShowLoginSuccess] = useState(false)

  useEffect(() => {
    if (window.localStorage.getItem('LoginToastShown') === 'true') {
      setShowLoginSuccess(true)
      setTimeout(() => {
        setShowLoginSuccess(false)
      }, 5000)
      window.localStorage.setItem('LoginToastShown', 'false')
    }
  }, [])

  const fetchExpiredTrips = () => {
    updateLoadExpired(true)
    const apiData = {
      firstCall: false,
      pageSize: 10,
      pageNo: data.page,
      tripStatus: 'expiredCompleted'
    }
    if (archivedTripsCall) {
      apiData.pageNo = 0
      apiData.tripStatus = 'archived'
      archivedTripsCallHandler(false)
    }
    if (apiData.pageNo >= getPageCount(expiredTripsCount, apiData.pageSize) && apiData.pageNo > 1) {
      apiData.tripStatus = 'archived'
      if (archivedTripsCount === 0) {
        apiData.pageNo = 0
        setDataHandler({ page: 0 })
      }
    } else if (archivedStarted &&
      apiData.pageNo >= getPageCount(archivedTripsCount, apiData.pageSize)) {
      apiData.tripStatus = 'archived'
    }
    httpAxios(FETCH_TRIPS_URL, POST_CALL, apiData)
      .then(res => {
        updateLoadExpired(false)
        const { pageNo } = apiData
        setDataHandler({ page: pageNo + 1 })
        let loadedData = []
        if (res.data.expiredTrips &&
          res.data.expiredTrips.tripListResponses &&
          res.data.expiredTrips.tripListResponses.length) {
          loadedData = res.data.expiredTrips.tripListResponses
          updateExpiredTripsCount(res.data.expiredTrips.totalElements)
        } else if (res.data.archivedTrips &&
          res.data.archivedTrips.tripListResponses &&
          res.data.archivedTrips.tripListResponses.length) {
          loadedData = res.data.archivedTrips.tripListResponses
          updateArchivedTripsCount(res.data.archivedTrips.totalElements)
          updateArchivedStart(true)
        } else {
          showLoadMoreHandler(false)
        }
        let tripsData = [...trips, ...loadedData]
        tripsData = makeArrayUnique(tripsData, 'tripId')
        updateTripsHandler(tripsData)
        if (res.data && res.data.length < 5) {
          showLoadMoreHandler(false)
        }
      })
      .catch(err => {
        updateLoadExpired(false)
        // const response = err
        // return response
      })
  }

  let tripsList = null
  if (tripsLoading) {
    tripsList = (
      <PageLoader
        title={TRIPS_LOAD_MSG_HEADING}
        message={TRIPS_LOAD_MSG_SUBHEADING}
      />
    )
  } else if (tripsLoadingFailed) {
    tripsList = (
      <List className="amt-10">
        <ListItem arrow={false} enableRipple={false}>
          <div className="flag h-15">
            <div className="flag__fix amr-15">
              <Warn fill="#c30" width="36px" height="36px" />
            </div>
            <div className="flag__flex">
              <h5 className="fs-17 lh-solid c-black-80">
                {TRIPS_FETCH_ERROR_MESSAGE}
              </h5>
            </div>
          </div>
        </ListItem>
      </List>
    )
  } else if (trips.length) {
    tripsList = (
      <List className="amt-10">
        {trips.map((trip, index) => (
          <TripsListItem
            tripDetails={trip}
            key={trip.trip_ref}
          />
        ))}
        <If condition={showLoadMore}>
          <ListItem arrow={false} enableRipple={true} className={loadExpired ? 'pr-0 pl-0 loading' : 'pr-0 pl-0'} onClick={fetchExpiredTrips}>
            <div className="flag h-12">
              <div className="flag__flex">
                <h5 className="ta-c fs-17 lh-solid c-blue tt-u">
                  {loadExpired ? 'Loading Trips...' : LOAD_MORE_TEXT}
                </h5>
              </div>
            </div>
          </ListItem>
        </If>
      </List>
    )
  } else {
    tripsList = (
      <List className="amt-10">
        <ListItem arrow={false} enableRipple={false}>
          <div className="flag h-15">
            <div className="flag__fix amr-15">
              <Trips fill="#36c" width="36px" height="36px" />
            </div>
            <div className="flag__flex">
              <h5 className="fs-17 lh-solid c-black-80">
                {TRIPS_NOT_AVAILABLE_MESSAGE}
              </h5>
            </div>
          </div>
        </ListItem>
      </List>
    )
  }

  return (
    <React.Fragment>
       <List className="amt-10">
        <ListItem arrow={false} enableRipple={false}>
          <div className="flag h-15">
            <div className="flag__fix amr-15">
              <Trips fill="#36c" width="36px" height="36px" />
            </div>
            <div className="flag__flex">
              <h5 className="fs-17 lh-solid c-black-80">
                {TRIPLIST_ALL_HEADER}
              </h5>
            </div>
          </div>
        </ListItem>
      </List>
      {tripsList}
      {
        showLoginSuccess && (
          <Toast
            message="Logged in successfully!"
            className="row mt-15 w-90p--xs w-585 walletErrorToast l-0 r-0 m-auto"
            closeBtn={false}
          />
        )}
    </React.Fragment>
  )
}

const TripListAll = () => {
  return (
    <TripState>
      <TripsList />
    </TripState>
  )
}

export default TripListAll
